/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"(valinnainen)\"]}");
//# sourceMappingURL=messages.mjs.map